import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {type TranslationObject} from '@colonist/i18n'
import {StoreProductType} from '../../../../shared/store/BaseColonistStoreProduct.ts'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper.ts'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints.ts'
import {UIPopupController} from '../ui_popup/UIPopupController.ts'
import {type ColonistOneTimePurchaseType} from '@colonist/types'
import {type GiftPurchaseData} from '../../../../shared/store/GiftPurchaseData.ts'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'

declare let stripe: any

export class UICheckoutAjaxEndPoints {
    static async executeStripeColonistProductPurchaseSession(storeProductType: StoreProductType, type: number, itemQuantity: number = 1) {
        const url = `${UIAPIEndpoints.apiPayGetStoreStripeSession()}/${storeProductType}/${type}/${itemQuantity}`
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, undefined)
        if(response == undefined) return

        void this.gotCheckoutSession(response.json as AjaxDataTypes.StripeCheckoutRequestStatus)
    }

    static async executeStripeColonistGiftPurchaseSession(purchaseType: ColonistOneTimePurchaseType, giftPurchaseData: GiftPurchaseData) {
        const storeProductType = StoreProductType.OneTimePurchase
        const url = `${UIAPIEndpoints.apiPayGetStoreStripeSession()}/${storeProductType}/${purchaseType}/${giftPurchaseData.duration}`
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, giftPurchaseData)
        if(response == undefined) return

        void this.gotCheckoutSession(response.json as AjaxDataTypes.StripeCheckoutRequestStatus)
    }

    static async gotCheckoutSession(response: AjaxDataTypes.StripeCheckoutRequestStatus) {
        if(!response.status) {
            UIPopupController.createSimplePopup({key: 'strings:storePage.errors.fail'}, response.message)
            return
        }

        const stripeRedirectResult = await stripe.redirectToCheckout({sessionId: response.session.id})
        const englishMessage: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: stripeRedirectResult.error.message}}
        UIPopupController.createSimplePopup({key: 'strings:storePage.errors.fail'}, englishMessage)
    }

    static async executeXsollaColonistCoinPurchaseSession(storeProductType: StoreProductType, type: number) {
        const url = `${UIAPIEndpoints.apiPayGetStoreXsollaSession()}/${storeProductType}/${type}`
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, undefined)
        if(response == undefined) return
        navigateToPage(response.json)
    }

    static async executeStripeCustomerPortalSession() {
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiPayCreateCustomerPortalSession(), undefined, undefined)
        if(response == undefined) return
        navigateToPage(response.json)
    }
}
